import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import TimeOff from '../../entities/timeOff';
export function deleteTimeOff(timeOff: TimeOff, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = timeOff.id;}
const _work = workingSet();




timeOff.status = 'D';
timeOff.addedOn = newHRTimestamp();
timeOff.addedBy = getCurrentUserId();
timeOff.importSource = targetImportSource;
timeOff.importId = mergeId;
store.dispatch(Actions.TimeOffActions.removeTimeOffQueue(timeOff));
}


